import Styled from 'styled-components';

export const MobileCTAButton = Styled.button`
  position: fixed;
  bottom: 2em;
  right: 1.25em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75em;
  border-radius: 30px;
  border: ${({ theme: { button } }) => button.borderWidth} solid ${({ theme: { button: { primary } } }) => primary.colorBackground};
  background: ${({ theme: { button: { primary } } }) => primary.colorBackground};
  color: ${({ theme }) => theme.colorWhite};
  box-shadow: ${({ theme: { button: { primary } } }) => primary.boxShadow};
  transition: border 100ms ease-out, background 100ms ease-out;

  &:hover,
  &:focus {
    background: ${({ theme: { button: { primary} } }) => primary.colorBackgroundHover};
    border: ${({ theme: { button } }) => button.borderWidth} solid ${({ theme: { button: { primary} } }) => primary.colorBackgroundHover};
  }

  * {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
